(function () {
  var SWIPER_OPTIONS = {
    slidesPerView: 1.2,
    spaceBetween: 16,
    speed: 450,
    grabCursor: true,
    watchOverflow: true,
    observer: true,
    observeParents: true,
    resizeObserver: true,
    breakpoints: {
      768: {
        slidesPerView: 2.5,
        spaceBetween: 24,
      },
             1025: {
        slidesPerView: 3.6,
        spaceBetween: 40,
      },
      1640:{
          slidesPerView: 4.6,
        spaceBetween: 40,
      }
    },
  };

  function wait(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  function getReviewSource(root) {
    return root.dataset.reviewSource || "auto";
  }

  var API_PER_PAGE = 50;
  var API_MAX_PAGES = 100;

  function wantsProductReviews(root) {
    var source = getReviewSource(root);
    if (source === "product_reviews") return true;
    if (source === "featured_carousel") return false;
    return Boolean(root.dataset.productId);
  }

  function getJudgeMeToken(root) {
    if (root.dataset.judgemeToken) return root.dataset.judgemeToken;

    var settings = window.jdgmSettings || window.judgemeSettings;
    if (settings) {
      return settings.api_token || settings.public_token || settings.shop_token || "";
    }

    if (window.jdgm) {
      return window.jdgm.apiToken || window.jdgm.publicToken || window.jdgm.token || "";
    }

    return "";
  }

  function waitForJudgeMeToken(root, attempt) {
    var token = getJudgeMeToken(root);
    if (token) return Promise.resolve(token);
    if ((attempt || 0) >= 30) return Promise.resolve("");
    var delay = (attempt || 0) < 12 ? 50 : 100;
    return wait(delay).then(function () {
      return waitForJudgeMeToken(root, (attempt || 0) + 1);
    });
  }

  function getReviewText(item) {
    var body =
      item.querySelector(".jdgm-carousel-item__review-body") ||
      item.querySelector(".jdgm-rev__body");
    var title =
      item.querySelector(".jdgm-carousel-item__review-title") ||
      item.querySelector(".jdgm-rev__title");
    return [body && body.textContent, title && title.textContent].join(" ").trim();
  }

  function getReviewKey(item) {
    if (typeof item === "object" && item.id) return String(item.id);
    if (item.getAttribute) {
      return (
        item.getAttribute("data-review-id") ||
        item.getAttribute("id") ||
        getReviewText(item)
      );
    }
    return getReviewText(item);
  }

  function hasReviewText(item) {
    if (item && item.body) return item.body.trim().length > 0;
    return getReviewText(item).length > 0;
  }

  function dedupeReviews(items) {
    var seen = new Set();
    return items.filter(function (item) {
      var key = getReviewKey(item);
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return hasReviewText(item);
    });
  }

  function extractReviewData(source) {
    if (source && source.body !== undefined) {
      return {
        id: source.id || source.body,
        score: source.score || 5,
        body: source.body || "",
        author: source.author || "",
      };
    }

    var ratingEl =
      source.querySelector(".jdgm-carousel-item__review-rating") ||
      source.querySelector(".jdgm-rev__rating");
    var bodyEl =
      source.querySelector(".jdgm-carousel-item__review-body") ||
      source.querySelector(".jdgm-rev__body");
    var authorEl =
      source.querySelector(".jdgm-carousel-item__reviewer-name") ||
      source.querySelector(".jdgm-rev__author") ||
      source.querySelector(".jdgm-rev__buyer");

    var score = 5;
    if (ratingEl) {
      var scoreAttr = ratingEl.getAttribute("data-score");
      if (scoreAttr) {
        score = Math.round(parseFloat(scoreAttr));
      } else {
        var label = ratingEl.getAttribute("aria-label") || ratingEl.textContent || "";
        var match = label.match(/(\d+(?:\.\d+)?)/);
        if (match) score = Math.round(parseFloat(match[1]));
      }
    }

    var bodyHtml = "";
    if (bodyEl) {
      var paragraph = bodyEl.querySelector("p");
      bodyHtml = paragraph ? paragraph.innerHTML : bodyEl.innerHTML;
    }

    return {
      id:
        source.getAttribute("data-review-id") ||
        source.getAttribute("id") ||
        (bodyEl && bodyEl.textContent.trim()) ||
        "",
      score: score,
      body: bodyHtml || (bodyEl ? bodyEl.textContent.trim() : ""),
      author: authorEl ? authorEl.textContent.trim() : "",
    };
  }

  function createStars(score) {
    var stars = document.createElement("div");
    stars.className = "contraband-reviews__stars";
    stars.setAttribute("role", "img");
    stars.setAttribute("aria-label", score + " stars");

    for (var i = 1; i <= 5; i += 1) {
      var star = document.createElement("span");
      star.className = "contraband-reviews__star" + (i <= score ? " is-on" : " is-off");
      star.setAttribute("aria-hidden", "true");
      star.textContent = "★";
      stars.appendChild(star);
    }

    return stars;
  }

  function createSlideFromReview(data) {
    var slide = document.createElement("div");
    slide.className = "contraband-reviews__slide-item";

    var wrapper = document.createElement("div");
    wrapper.className = "contraband-reviews__card-wrapper";

    var card = document.createElement("div");
    card.className = "contraband-reviews__card";

    var bodyWrap = document.createElement("div");
    bodyWrap.className = "contraband-reviews__card-body";

    bodyWrap.appendChild(createStars(data.score));

    if (data.body) {
      var body = document.createElement("div");
      body.className = "contraband-reviews__review-body font-secondary";
      body.innerHTML = data.body;
      bodyWrap.appendChild(body);
    }

    if (data.author) {
      var author = document.createElement("p");
      author.className = "contraband-reviews__review-author font-secondary";
      author.textContent = data.author;
      bodyWrap.appendChild(author);
    }

    card.appendChild(bodyWrap);
    wrapper.appendChild(card);
    slide.appendChild(wrapper);

    if (data.id) slide.setAttribute("data-review-id", data.id);

    return slide;
  }

  function getSwiperMount(root) {
    var widget = root.querySelector(".contraband-reviews__widget");
    if (!widget) return null;

    var mount = widget.querySelector(".contraband-reviews__swiper-mount");
    if (mount) return mount;

    mount = document.createElement("div");
    mount.className = "contraband-reviews__swiper-mount";
    widget.appendChild(mount);
    return mount;
  }

  function destroySwiper(root) {
    if (root._swiperInstance) {
      root._swiperInstance.destroy(true, true);
      root._swiperInstance = null;
    }
    root.dataset.swiperInit = "false";
  }

  function buildSwiper(root, reviewDataList, attempt) {
    if (!reviewDataList.length) return false;

    if (typeof Swiper === "undefined") {
      if ((attempt || 0) < 40) {
        window.setTimeout(function () {
          buildSwiper(root, reviewDataList, (attempt || 0) + 1);
        }, 150);
      }
      return false;
    }

    destroySwiper(root);

    var mount = getSwiperMount(root);
    if (!mount) return false;

    mount.innerHTML = "";

    var swiperRoot = document.createElement("div");
    swiperRoot.className = "contraband-reviews-swiper swiper";
    var track = document.createElement("div");
    track.className = "swiper-wrapper";

    reviewDataList.forEach(function (data) {
      var slide = document.createElement("div");
      slide.className = "swiper-slide";
      slide.appendChild(createSlideFromReview(data));
      track.appendChild(slide);
    });

    swiperRoot.appendChild(track);
    mount.appendChild(swiperRoot);

    root._swiperInstance = new Swiper(swiperRoot, SWIPER_OPTIONS);
    root.dataset.swiperInit = "true";
    root.dataset.reviewCount = String(reviewDataList.length);

    window.requestAnimationFrame(function () {
      if (root._swiperInstance) root._swiperInstance.update();
    });

    return true;
  }

  function getProductReviewWidget(root) {
    return root.querySelector("#judgeme_product_reviews, .jdgm-review-widget");
  }

  function getProductReviewElements(root) {
    var widget = getProductReviewWidget(root);
    if (!widget) return [];
    return Array.from(widget.querySelectorAll(".jdgm-rev")).filter(hasReviewText);
  }

  function parseReviewsFromWidgetHtml(html) {
    var temp = document.createElement("div");
    temp.innerHTML = html;
    return Array.from(temp.querySelectorAll(".jdgm-rev"))
      .filter(hasReviewText)
      .map(extractReviewData);
  }

  function clickPaginationPage(widget, pageNum) {
    var link = widget.querySelector('.jdgm-paginate .jdgm-paginate__page[data-page="' + pageNum + '"]');
    if (!link || link.classList.contains("jdgm-disabled") || link.classList.contains("jdgm-curt")) {
      return false;
    }
    link.click();
    return true;
  }

  async function fetchProductReviewsFromApi(root) {
    var shopDomain = root.dataset.shopDomain;
    var productId = root.dataset.productId;
    if (!shopDomain || !productId) return [];

    var token = await waitForJudgeMeToken(root, 0);
    if (!token) return [];

    var collected = [];
    var page = 1;
    var confirmedEmpty = false;

    while (page <= API_MAX_PAGES) {
      var url =
        "https://judge.me/api/v1/widgets/product_review?shop_domain=" +
        encodeURIComponent(shopDomain) +
        "&api_token=" +
        encodeURIComponent(token) +
        "&external_id=" +
        encodeURIComponent(productId) +
        "&page=" +
        page +
        "&per_page=" +
        API_PER_PAGE;

      try {
        var res = await fetch(url);
        if (!res.ok) break;

        var data = await res.json();
        if (!data || !data.widget) break;

        var pageItems = parseReviewsFromWidgetHtml(data.widget);
        if (!pageItems.length) {
          confirmedEmpty = page === 1;
          break;
        }

        collected = collected.concat(pageItems);
        collected = dedupeReviews(collected);

        if (pageItems.length < API_PER_PAGE) break;
        page += 1;
      } catch (err) {
        break;
      }
    }

    if (confirmedEmpty || collected.length) {
      root._apiConfirmedEmpty = confirmedEmpty && !collected.length;
    }

    return collected;
  }

  function getPaginationPageNumbers(widget) {
    var pageNumbers = [];

    widget.querySelectorAll(".jdgm-paginate .jdgm-paginate__page[data-page]").forEach(function (link) {
      var num = parseInt(link.getAttribute("data-page"), 10);
      if (Number.isFinite(num) && pageNumbers.indexOf(num) === -1) {
        pageNumbers.push(num);
      }
    });

    pageNumbers.sort(function (a, b) {
      return a - b;
    });

    return pageNumbers;
  }

  async function waitForWidgetPagination(root, maxAttempts) {
    for (var i = 0; i < (maxAttempts || 60); i += 1) {
      var widget = getProductReviewWidget(root);
      if (!widget) {
        await wait(200);
        continue;
      }

      if (getProductReviewElements(root).length) {
        var pages = getPaginationPageNumbers(widget);
        if (pages.length) return widget;
        if (i >= 15) return widget;
      }

      await wait(200);
    }

    return getProductReviewWidget(root);
  }

  async function loadAllReviewsViaWidgetPagination(root) {
    var widget = await waitForWidgetPagination(root, 60);
    if (!widget) return [];

    var collected = [];

    function snapshot() {
      getProductReviewElements(root).forEach(function (el) {
        collected.push(extractReviewData(el));
      });
      collected = dedupeReviews(collected);
    }

    var pageNumbers = getPaginationPageNumbers(widget);

    if (!pageNumbers.length) {
      snapshot();
      return collected;
    }

    for (var i = 0; i < pageNumbers.length; i += 1) {
      clickPaginationPage(widget, pageNumbers[i]);
      await wait(350);
      snapshot();
    }

    return collected;
  }

  async function waitForDomReviews(root, maxAttempts) {
    for (var i = 0; i < (maxAttempts || 50); i += 1) {
      var els = getProductReviewElements(root);
      if (els.length) {
        return els.map(extractReviewData);
      }
      await wait(200);
    }
    return [];
  }

  function prefetchProductReviews(root) {
    if (!wantsProductReviews(root)) return null;
    if (root._prefetchPromise) return root._prefetchPromise;
    root._prefetchPromise = fetchProductReviewsFromApi(root);
    return root._prefetchPromise;
  }

  function widgetReportsZeroReviews(root) {
    var scope = root.closest(".shopify-section") || root;
    var widgets = scope.querySelectorAll(
      "#judgeme_product_reviews, .jdgm-review-widget, .jdgm-rev-widg"
    );

    for (var i = 0; i < widgets.length; i += 1) {
      var widget = widgets[i];
      var countAttr =
        widget.getAttribute("data-number-of-reviews") ||
        widget.getAttribute("data-average-rating");
      if (countAttr === "0") return true;

      if (widget.querySelector(".jdgm-rev")) return false;

      var emptyText = (widget.textContent || "").toLowerCase();
      if (
        emptyText.indexOf("be the first to write a review") !== -1 ||
        emptyText.indexOf("no reviews") !== -1
      ) {
        return true;
      }
    }

    return false;
  }

  async function collectProductReviews(root) {
    if (root._cachedReviews && root._cachedReviews.length) {
      return root._cachedReviews;
    }

    var fromApi = await (root._prefetchPromise || fetchProductReviewsFromApi(root));
    if (fromApi.length) {
      root._cachedReviews = fromApi;
      return fromApi;
    }

    /* Confirmed empty from API/widget — skip long DOM polling that leaves blank space */
    if (root._apiConfirmedEmpty || widgetReportsZeroReviews(root)) {
      root._cachedReviews = [];
      return [];
    }

    var quickDom = await waitForDomReviews(root, 10);
    var merged = dedupeReviews(quickDom);

    if (!merged.length && widgetReportsZeroReviews(root)) {
      root._cachedReviews = [];
      return [];
    }

    if (!merged.length) {
      var fromPagination = await loadAllReviewsViaWidgetPagination(root);
      merged = dedupeReviews(fromPagination);
    }

    if (!merged.length) {
      merged = dedupeReviews(getProductReviewElements(root).map(extractReviewData));
    }

    root._cachedReviews = merged;
    return merged;
  }

  function getFeaturedCarouselItems(root) {
    var carousel = root.querySelector("section.jdgm-carousel, .jdgm-carousel");
    if (!carousel) return [];

    var itemWrapper = carousel.querySelector(".jdgm-carousel__item-wrapper");
    if (!itemWrapper) return [];

    return Array.from(itemWrapper.querySelectorAll(".jdgm-carousel-item"))
      .filter(hasReviewText)
      .map(extractReviewData);
  }

  async function waitForFeaturedCarouselItems(root, maxAttempts) {
    for (var i = 0; i < (maxAttempts || 40); i += 1) {
      var reviews = getFeaturedCarouselItems(root);
      if (reviews.length) return reviews;
      await wait(150);
    }
    return [];
  }

  async function enhanceFeaturedCarousel(root) {
    var reviews = await waitForFeaturedCarouselItems(root, 40);
    if (!reviews.length) return false;

    if (!buildSwiper(root, reviews, 0)) return false;

    var carousel = root.querySelector("section.jdgm-carousel, .jdgm-carousel");
    if (carousel) {
      var container = carousel.querySelector(".jdgm-carousel__item-container") || carousel;
      container.innerHTML = "";
    }

    root.dataset.reviewMode = "featured";
    root.classList.remove("contraband-reviews--product-reviews");
    return true;
  }

  async function enhanceProductReviews(root) {
    if (!root.dataset.productId && !getProductReviewWidget(root)) return false;

    var reviews = await collectProductReviews(root);
    if (!reviews.length) return false;

    if (!buildSwiper(root, reviews, 0)) return false;

    root.dataset.reviewMode = "product";
    root.classList.add("contraband-reviews--product-reviews");
    return true;
  }

  function hideEmptySwiper(root) {
    if (!root) return;

    root.classList.add("contraband-reviews--empty", "is-ready");
    root.dataset.empty = "true";

    var loading = root.querySelector(".contraband-reviews__loading");
    if (loading) loading.hidden = true;

    var nav = root.querySelector("[data-contraband-next]");
    if (nav) nav.hidden = true;

    var mount = root.querySelector(".contraband-reviews__swiper-mount");
    if (mount) {
      mount.hidden = true;
      mount.setAttribute("aria-hidden", "true");
    }
  }

  async function enhanceReviewsCarousel(root) {
    if (!root || root.dataset.enhanced === "true" || root.dataset.empty === "true") return false;

    var enhanced = false;
    var source = getReviewSource(root);

    if (wantsProductReviews(root)) {
      enhanced = await enhanceProductReviews(root);
    }

    /* Featured fallback only for auto / featured — not strict product_reviews */
    if (!enhanced && source !== "product_reviews") {
      enhanced = await enhanceFeaturedCarousel(root);
    }

    if (!enhanced) {
      hideEmptySwiper(root);
      return false;
    }

    root.dataset.enhanced = "true";
    root.classList.add("is-ready");
    return true;
  }

  function resetSection(root) {
    destroySwiper(root);

    root.dataset.enhanced = "false";
    root.dataset.reviewMode = "";
    root.dataset.empty = "false";
    root._cachedReviews = null;
    root._prefetchPromise = null;
    root._apiConfirmedEmpty = false;

    root.classList.remove("is-ready", "contraband-reviews--product-reviews", "contraband-reviews--empty");

    var loading = root.querySelector(".contraband-reviews__loading");
    if (loading) loading.hidden = false;

    var nav = root.querySelector("[data-contraband-next]");
    if (nav) nav.hidden = false;

    var mount = root.querySelector(".contraband-reviews__swiper-mount");
    if (mount) {
      mount.hidden = false;
      mount.removeAttribute("aria-hidden");
      mount.remove();
    }
  }

  function watchSection(root) {
    if (!root) return;

    prefetchProductReviews(root);

    var loadPromise = null;

    function tryEnhance() {
      if (root.dataset.enhanced === "true" || root.dataset.empty === "true") {
        return Promise.resolve(root.dataset.enhanced === "true");
      }
      if (loadPromise) return loadPromise;

      loadPromise = enhanceReviewsCarousel(root).finally(function () {
        loadPromise = null;
      });

      return loadPromise;
    }

    tryEnhance();

    var observer = new MutationObserver(function () {
      if (root.dataset.enhanced !== "true") tryEnhance();
    });

    observer.observe(root, {
      childList: true,
      subtree: true,
    });

    var attempts = 0;
    var interval = window.setInterval(function () {
      tryEnhance();
      attempts += 1;
      if (
        root.classList.contains("is-ready") ||
        root.classList.contains("contraband-reviews--empty") ||
        root.dataset.empty === "true" ||
        attempts > 80
      ) {
        window.clearInterval(interval);
      }
    }, 400);
  }

  function init() {
    document.querySelectorAll("[data-contraband-reviews]").forEach(watchSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target.querySelector("[data-contraband-reviews]");
    if (section) {
      resetSection(section);
      watchSection(section);
    }
  });
})();
